import type { EventStatus } from '../data';

function toDateOnly(value: string) {
  return value.trim().split(/[T ]/)[0];
}

function formatDate(value: string) {
  return toDateOnly(value).replaceAll('-', '.');
}

function formatPeriodRange(start: string, end?: string) {
  const formattedStart = formatDate(start);
  if (!end) return `${formattedStart}~`;

  const formattedEnd = formatDate(end);
  if (toDateOnly(start) === toDateOnly(end)) return formattedStart;

  return `${formattedStart}~${formattedEnd}`;
}

interface HubEventPeriodTextProps {
  status: EventStatus | null;
  className: string;
}

export function HubEventPeriodText({ status, className }: HubEventPeriodTextProps) {
  if (!status?.range) return null;

  return (
    <span className={className}>
      {formatPeriodRange(status.range.start, status.range.end)}
    </span>
  );
}
